import React, { useEffect, useState } from "react";
import { View, Platform } from "react-native";
import AppActivityIndicator from "../../shared/AppActivityIndicator";
import useKeypress from "../../hooks/useKeypress";
import { fetchGuests } from "../../http/events";
import AddGuestForm from "../../shared/AddGuestForm";
import AppHeader, { onBackPressed } from "../../shared/AppHeader";
import { AppSimpleHeaderButton } from "../../shared/Buttons";
import { SettingsPage } from "@/components/settings/SettingsPage";
import { CONTENT_MAX_WIDTH } from "@/components/settings/theme";
import AppContent from "../../shared/AppContent";
import Container from "@/components/shared/AppContainer";
import { t } from "@/localization";

const GuestAdd = ({ navigation, route }) => {
  const [loading, setloading] = useState(true);
  const { slug } = route.params;

  const [event, setEvent] = useState({ slug });

  useEffect(() => {
    const fetchAsync = async () => {
      try {
        const myEvent = await fetchGuests(slug);
        setEvent(myEvent);
        setloading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAsync();
  }, [slug]);

  if (Platform.OS === "web")
    useKeypress("Escape", () => onBackPressed(navigation, route));

  return (
    <Container>
      <AppHeader
        leftButtonComponent={
          <AppSimpleHeaderButton
            onPress={() => onBackPressed(navigation, route)}
            text={t("Cancel")}
          />
        }
        renderRightButton={() =>
          event.stream_key && (
            <AppSimpleHeaderButton
              onPress={() => {
                if (event.is_published) {
                  navigation.navigate("GuestImport", {
                    slug,
                  });
                } else {
                  navigation.navigate("PayWall", {
                    event,
                    slug,
                  });
                }
              }}
              text={t("Import")}
            />
          )
        }
      />
      <AppContent
        isTopAligned
        padding={0}
        contentContainerStyle={{ paddingTop: 8 }}
      >
        {loading && <AppActivityIndicator />}
        {!loading && (
          <View
            style={{
              flex: 1,
              flexDirection: "column",
              paddingHorizontal: 20,
              maxWidth: CONTENT_MAX_WIDTH + 40,
              width: "100%",
              alignSelf: "center",
            }}
          >
            <SettingsPage
              title={t("Invite a guest")}
              help="guests.invite"
              description={t(
                "We'll email them the event link and remind them before you go live."
              )}
            >
              <AddGuestForm event={event} />
            </SettingsPage>
          </View>
        )}
      </AppContent>
    </Container>
  );
};

export default GuestAdd;
